import React, { FunctionComponent } from 'react'
import { SVGProps } from 'interfaces'

const SVG: FunctionComponent<SVGProps> = ({ className }) => (
    <svg width='100%' className={className} viewBox='0 0 17 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M2.09473 8.125C2.09473 7.8125 2.41963 7.5 2.74453 7.5C3.06943 7.5 3.39433 7.8125 3.39433 8.125C3.39433 8.33333 3.39433 9.375 3.39433 11.25C3.39433 11.9404 3.97618 12.5 4.69393 12.5H12.4916C13.2093 12.5 13.7912 11.9404 13.7912 11.25V8.125C13.7912 7.77982 14.0821 7.5 14.441 7.5C14.7998 7.5 15.0908 7.77982 15.0908 8.125V11.25C15.0908 12.6307 13.9271 13.75 12.4916 13.75H4.69393C3.25843 13.75 2.09473 12.6307 2.09473 11.25C2.09473 9.375 2.09473 8.33333 2.09473 8.125Z'
            fill='#222222'
        />
        <path
            d='M7.94063 8.75C7.94063 9.09518 8.23156 9.375 8.59043 9.375C8.94931 9.375 9.24023 9.09518 9.24023 8.75L9.24023 1.25C9.24023 0.904822 8.94931 0.625 8.59043 0.625C8.23156 0.625 7.94063 0.904822 7.94063 1.25L7.94063 8.75Z'
            fill='#222222'
        />
        <path
            d='M11.381 5.80818C11.6347 5.5641 12.0461 5.5641 12.2999 5.80818C12.5537 6.05226 12.5537 6.44799 12.2999 6.69206L9.0509 9.81706C8.80653 10.0521 8.41362 10.0621 8.15673 9.83968L4.90772 7.02718C4.64097 6.79627 4.61935 6.40109 4.85942 6.14452C5.0995 5.88795 5.51036 5.86715 5.77711 6.09806L8.56788 8.51389L11.381 5.80818Z'
            fill='#222222'
        />
    </svg>
)

export default SVG
